// List of FTTB package IDs
export const fttbPackageIds = [
  22559823, // Octotel 50/50Mbps FTTB
  22559851, // Openserve Office Connect 50/50Mbps
  22559852, // Openserve Office Connect 100/100Mbps
  22559853, // Openserve Office Connect 200/200Mbps
  22559854, // Openserve Office Connect 300/300Mbps
  22559855, // Openserve Office Connect 500/500Mbps
  22559879, // OpenServe SMB FTTB 200/200Mbps
  22559880, // OpenServe SMB FTTB 50/50Mbps
  22559881, // OpenServe SMB FTTB 100/100Mbps
  22559882, // OpenServe SMB FTTB 300/150Mbps
  22559883, // OpenServe SMB FTTB 500/250Mbps
  22559890, // Metrofibre 20/20Mbps SME FTTB
  22559891, // Metrofibre 50/50Mbps SME FTTB
  22559892, // Metrofibre 100/100Mbps SME FTTB
  22559893, // Metrofibre 200/200Mbps SME FTTB
  22559894, // Metrofibre 500/500Mbps SME FTTB
  22559895, // Metrofibre 1000/1000Mbps SME FTTB
  22559900, // Octotel 5/5Mbps FTTB
  22559901, // Octotel 10/10Mbps FTTB
  22559902, // Octotel 100/100Mbps FTTB
  22559903, // Octotel 200/200Mbps FTTB
  22559904, // Octotel 300/300Mbps FTTB
  22559905  // Octotel 1000/500Mbps FTTB
];